import { RulesContent } from 'schemas/Content.schema';

const VaccinationsRulesContent: RulesContent[] = [
  {
    name: 'Filter',
    type: 'F',
    description: 'Filter rules exclude people who should not get an invitation at this time. For example, they do not meet the eligibility criteria or have recently been vaccinated.',
  },
  {
    name: 'Suppression',
    type: 'S',
    description: 'Suppression rules exclude people who are eligible for a vaccination but should not receive an invitation. For example, they have opted out or are managed by another service, such as a care home.',
  },
  {
    name: 'Routing',
    type: 'R',
    description: 'Routing rules let you use different message plans for different groups. For example, you can set up a separate plan for under-16s or people who need accessible formats.',
  },
];

export default VaccinationsRulesContent;
